module.exports = __webpack_public_path__ + "static/modal-charleston-e2aa30f5500eae14d56c2729150c346e.jpg";